import Seo from "../components/generic/Seo";
import SeplourWork from "../components/SeplWork/SeplourWork";

const objSeo = {
  title: "Springevening Private Limited - Designed Developed Deployed",
  keywords:
    "startup, Software company, Soochi ERP, HappyNenapu, Flipbook, Shyam, shyamsunder sedamkar, sedamkar, shivoo, ashok sutagundar, BEC,Empowering developers, Training, Internship, Bagalkot, BEC, sedamkar, North Karnataka",
  pathSlug: "/ourwork",
  description:
    "Our work showcases our commitment to excellence in software development, design, and deployment. Each project reflects our dedication to quality and innovation, ensuring that we deliver solutions that not only meet but exceed client expectations.",
};

const Ourwork = () => {
  return (
    <div>
      <Seo data={objSeo} />
      <SeplourWork />
    </div>
  );
};

export default Ourwork;
